import React, { useState, useEffect, useRef } from "react";
import "./../../../assets/css/student/MyMentor.css";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";


// ─── SVG ICON SYSTEM ─────────────────────────────────────────────────────────

const Icons = {
  Mentors: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="7" r="3"/><path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/>
      <circle cx="18" cy="8" r="2"/><path d="M21 21v-1.5a3 3 0 0 0-3-3h-1"/>
    </svg>
  ),
  Sessions: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/>
      <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
      <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01"/>
    </svg>
  ),
  Star: ({ filled }) => (
    <svg viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  Rating: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  Pending: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  Chat: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  ),
  Book: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </svg>
  ),
  Profile: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  Report: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  Cards: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
    </svg>
  ),
  Analytics: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
  ),
  Communication: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36a2 2 0 0 1 1.99-2.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 9a16 16 0 0 0 6 6l.92-.92a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  ),
  Close: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  AI: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2z"/>
      <circle cx="7.5" cy="14.5" r="1.5"/><circle cx="16.5" cy="14.5" r="1.5"/>
    </svg>
  ),
  Arrow: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </svg>
  ),
  TrendUp: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
    </svg>
  ),
  Clock: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  Send: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
    </svg>
  ),
  File: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
      <polyline points="13 2 13 9 20 9"/>
    </svg>
  ),
  Code: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
    </svg>
  ),
};

// ─── DATA ────────────────────────────────────────────────────────────────────

const MENTORS = [
  {
    id: 1,
    name: "Sarah Chen",
    title: "Senior React Engineer",
    expertise: ["React", "TypeScript", "Performance"],
    course: "Advanced React Patterns",
    rating: 4.9,
    reviewCount: 124,
    status: "Active",
    match: 92,
    color: "#7C3AED",
    stats: { improvement: 32, reviews: 48, responseTime: "1.2h", successRate: 94 },
    sessions: [
      { date: "Apr 15, 2026", time: "3:00 PM", topic: "React Server Components", status: "upcoming" },
      { date: "Apr 8, 2026", time: "2:00 PM", topic: "Custom Hooks Deep Dive", status: "completed" },
    ],
    messages: [
      { from: "mentor", text: "Great work on the assignment! Your hook implementation was clean.", time: "2h ago" },
      { from: "student", text: "Thank you! I had a question about dependency arrays.", time: "1h ago" },
      { from: "mentor", text: "Sure, let's cover that in our next session on Tuesday.", time: "45m ago" },
    ],
    slots: ["Mon 10:00", "Mon 14:00", "Tue 15:00", "Wed 11:00", "Thu 16:00"],
    activeStudents: 18,
    courses: ["Advanced React Patterns", "TypeScript Mastery"],
    insight: "Students under this mentor improve 32% faster in React",
  },
  {
    id: 2,
    name: "Marcus Webb",
    title: "AI/ML Architect",
    expertise: ["Python", "AI/ML", "LLMs"],
    course: "Machine Learning Fundamentals",
    rating: 4.7,
    reviewCount: 89,
    status: "Active",
    match: 87,
    color: "#0EA5E9",
    stats: { improvement: 28, reviews: 62, responseTime: "0.8h", successRate: 91 },
    sessions: [
      { date: "Apr 17, 2026", time: "11:00 AM", topic: "Neural Network Architecture", status: "upcoming" },
      { date: "Apr 10, 2026", time: "10:00 AM", topic: "PyTorch Fundamentals", status: "completed" },
    ],
    messages: [
      { from: "mentor", text: "Your model accuracy reached 89% — outstanding progress!", time: "3h ago" },
      { from: "student", text: "I want to understand overfitting better.", time: "2h ago" },
    ],
    slots: ["Tue 9:00", "Tue 13:00", "Wed 15:00", "Fri 10:00"],
    activeStudents: 24,
    courses: ["Machine Learning Fundamentals", "LLM Engineering"],
    insight: "Fastest response mentor in AI/ML category",
  },
  {
    id: 3,
    name: "Priya Nair",
    title: "Backend Systems Lead",
    expertise: ["Node.js", "PostgreSQL", "System Design"],
    course: "Backend Architecture",
    rating: 4.8,
    reviewCount: 67,
    status: "Active",
    match: 79,
    color: "#10B981",
    stats: { improvement: 25, reviews: 34, responseTime: "2.1h", successRate: 88 },
    sessions: [
      { date: "Apr 20, 2026", time: "4:00 PM", topic: "Database Optimization", status: "upcoming" },
    ],
    messages: [
      { from: "mentor", text: "Review the indexing strategies doc I shared.", time: "1d ago" },
      { from: "student", text: "Done! Should I implement it in the project?", time: "5h ago" },
    ],
    slots: ["Mon 16:00", "Wed 9:00", "Thu 14:00", "Fri 13:00"],
    activeStudents: 12,
    courses: ["Backend Architecture", "System Design Patterns"],
    insight: "High assignment approval rate among backend mentors",
  },
  {
    id: 4,
    name: "Jordan Lee",
    title: "Frontend Design Engineer",
    expertise: ["CSS", "Design Systems", "Animations"],
    course: "UI Engineering",
    rating: 4.6,
    reviewCount: 45,
    status: "Pending",
    match: 74,
    color: "#F59E0B",
    stats: { improvement: 20, reviews: 28, responseTime: "3.4h", successRate: 85 },
    sessions: [],
    messages: [],
    slots: ["Tue 11:00", "Thu 10:00", "Fri 15:00"],
    activeStudents: 9,
    courses: ["UI Engineering", "Advanced CSS"],
    insight: "Specializes in design system architecture",
  },
];

const KPI_DATA = [
  { label: "Active Mentors", value: "3", icon: "Mentors", color: "#7C3AED", bg: "#F5F3FF" },
  { label: "Sessions Completed", value: "24", icon: "Sessions", color: "#0EA5E9", bg: "#F0F9FF" },
  { label: "Average Rating", value: "4.8", icon: "Rating", color: "#F59E0B", bg: "#FFFBEB" },
  { label: "Pending Requests", value: "1", icon: "Pending", color: "#EF4444", bg: "#FEF2F2" },
];

// ─── COMPONENTS ──────────────────────────────────────────────────────────────

function StarRating({ rating }) {
  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((s) => (
        <span key={s} className={`star ${s <= Math.round(rating) ? "filled" : ""}`} style={{ color: s <= Math.round(rating) ? "#F59E0B" : "#D1D5DB" }}>
          <Icons.Star filled={s <= Math.round(rating)} />
        </span>
      ))}
      <span className="rating-num">{rating}</span>
    </div>
  );
}

function KPIWidget({ label, value, icon, color, bg }) {
  const IconComp = Icons[icon];
  return (
    <div className="kpi-card" style={{ "--accent": color, "--bg": bg }}>
      <div className="kpi-icon" style={{ background: bg, color }}>
        <IconComp />
      </div>
      <div className="kpi-body">
        <div className="kpi-value">{value}</div>
        <div className="kpi-label">{label}</div>
      </div>
      <div className="kpi-bar" style={{ background: color }} />
    </div>
  );
}

function StatusBadge({ status }) {
  const map = { Active: "badge-active", Pending: "badge-pending", Requested: "badge-requested" };
  return <span className={`badge ${map[status] || "badge-active"}`}>{status}</span>;
}

function MentorCard({ mentor, onSelect, onChat, onBook }) {
  const initials = mentor.name.split(" ").map((n) => n[0]).join("");
  return (
    <div className="mentor-card" onClick={() => onSelect(mentor)}>
      <div className="card-header-strip" style={{ background: mentor.color }} />
      <div className="card-top">
        <div className="avatar" style={{ background: mentor.color }}>
          {initials}
        </div>
        <div className="card-meta">
          <StatusBadge status={mentor.status} />
          <div className="ai-match">
            <span className="ai-icon"><Icons.AI /></span>
            {mentor.match}% match
          </div>
        </div>
      </div>
      <div className="card-info">
        <h3 className="mentor-name">{mentor.name}</h3>
        <p className="mentor-title">{mentor.title}</p>
        <StarRating rating={mentor.rating} />
        <p className="review-count">{mentor.reviewCount} reviews</p>
        <div className="expertise-tags">
          {mentor.expertise.map((tag) => (
            <span key={tag} className="tag">{tag}</span>
          ))}
        </div>
        <div className="course-assoc">
          <Icons.Book /> <span>{mentor.course}</span>
        </div>
      </div>
      <div className="card-actions" onClick={(e) => e.stopPropagation()}>
        <button className="btn-chat" onClick={() => onChat(mentor)}>
          <Icons.Chat /> Chat
        </button>
        <button className="btn-book" onClick={() => onBook(mentor)}>
          <Icons.Book /> Book
        </button>
        <button className="btn-profile" onClick={() => onSelect(mentor)}>
          <Icons.Profile /> Profile
        </button>
        <button className="btn-report">
          <Icons.Report />
        </button>
      </div>
    </div>
  );
}

function ProgressBar({ value, color }) {
  return (
    <div className="progress-track">
      <div className="progress-fill" style={{ width: `${value}%`, background: color }} />
    </div>
  );
}

function MiniChart({ data, color }) {
  const max = Math.max(...data);
  const pts = data.map((v, i) => `${(i / (data.length - 1)) * 100},${100 - (v / max) * 80}`).join(" ");
  return (
    <svg className="mini-chart" viewBox="0 0 100 100" preserveAspectRatio="none">
      <defs>
        <linearGradient id={`g${color.replace("#","")}`} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.3" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polyline points={pts} fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <polygon points={`0,100 ${pts} 100,100`} fill={`url(#g${color.replace("#","")})`} />
    </svg>
  );
}

function PerformanceCard({ mentor }) {
  const chartData = [60, 65, 70, 68, 75, 80, mentor.stats.successRate];
  return (
    <div className="perf-card">
      <div className="perf-head">
        <div className="avatar sm" style={{ background: mentor.color }}>
          {mentor.name.split(" ").map((n) => n[0]).join("")}
        </div>
        <div>
          <div className="mentor-name">{mentor.name}</div>
          <div className="mentor-title">{mentor.title}</div>
        </div>
        <div className="perf-chart-wrap">
          <MiniChart data={chartData} color={mentor.color} />
        </div>
      </div>
      <div className="perf-metrics">
        <div className="metric">
          <div className="metric-label">Progress Improvement</div>
          <div className="metric-row">
            <ProgressBar value={mentor.stats.improvement} color={mentor.color} />
            <span className="metric-val" style={{ color: mentor.color }}>+{mentor.stats.improvement}%</span>
          </div>
        </div>
        <div className="metric">
          <div className="metric-label">Success Rate</div>
          <div className="metric-row">
            <ProgressBar value={mentor.stats.successRate} color="#10B981" />
            <span className="metric-val" style={{ color: "#10B981" }}>{mentor.stats.successRate}%</span>
          </div>
        </div>
        <div className="perf-row2">
          <div className="metric-chip">
            <Icons.File />
            <div><div className="chip-val">{mentor.stats.reviews}</div><div className="chip-lab">Reviews</div></div>
          </div>
          <div className="metric-chip">
            <Icons.Clock />
            <div><div className="chip-val">{mentor.stats.responseTime}</div><div className="chip-lab">Avg Response</div></div>
          </div>
          <div className="metric-chip trend">
            <Icons.TrendUp />
            <div><div className="chip-val">Top 10%</div><div className="chip-lab">Ranking</div></div>
          </div>
        </div>
      </div>
      <div className="perf-insight">
        <span className="insight-icon"><Icons.AI /></span>
        <span>{mentor.insight}</span>
      </div>
    </div>
  );
}

function ChatPanel({ mentor }) {
  const [msg, setMsg] = useState("");
  const [messages, setMessages] = useState(mentor?.messages || []);
  const endRef = useRef(null);

  useEffect(() => {
    setMessages(mentor?.messages || []);
  }, [mentor]);

  const send = () => {
    if (!msg.trim()) return;
    setMessages((prev) => [...prev, { from: "student", text: msg, time: "just now" }]);
    setMsg("");
  };

  return (
    <div className="chat-panel">
      <div className="chat-header">
        <div className="avatar sm" style={{ background: mentor.color }}>
          {mentor.name.split(" ").map((n) => n[0]).join("")}
        </div>
        <div>
          <div className="chat-name">{mentor.name}</div>
          <div className="chat-status-dot">Online</div>
        </div>
      </div>
      <div className="chat-messages">
        {messages.length === 0 && (
          <div className="chat-empty">Start your conversation with {mentor.name}</div>
        )}
        {messages.map((m, i) => (
          <div key={i} className={`chat-bubble ${m.from === "mentor" ? "bubble-mentor" : "bubble-student"}`}>
            <div className="bubble-text">{m.text}</div>
            <div className="bubble-time">{m.time}</div>
          </div>
        ))}
        <div ref={endRef} />
      </div>
      <div className="chat-input-bar">
        <button className="input-action"><Icons.Code /></button>
        <button className="input-action"><Icons.File /></button>
        <input
          className="chat-input"
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
          placeholder="Type a message..."
          onKeyDown={(e) => e.key === "Enter" && send()}
        />
        <button className="btn-send" onClick={send}><Icons.Send /></button>
      </div>
    </div>
  );
}

function SessionCard({ session }) {
  return (
    <div className={`session-card ${session.status}`}>
      <div className="session-date">
        <Icons.Sessions />
        <span>{session.date} · {session.time}</span>
      </div>
      <div className="session-topic">{session.topic}</div>
      <span className={`session-badge ${session.status}`}>{session.status}</span>
    </div>
  );
}

function CommView({ mentors, onChat }) {
  const [active, setActive] = useState(mentors[0]);
  return (
    <div className="comm-layout">
      <div className="comm-sidebar">
        <div className="comm-sidebar-title">Conversations</div>
        {mentors.map((m) => (
          <div key={m.id} className={`comm-thread ${active?.id === m.id ? "active-thread" : ""}`} onClick={() => setActive(m)}>
            <div className="avatar sm" style={{ background: m.color }}>{m.name.split(" ").map((n) => n[0]).join("")}</div>
            <div className="thread-info">
              <div className="thread-name">{m.name}</div>
              <div className="thread-last">{m.messages[m.messages.length - 1]?.text?.slice(0, 28) || "No messages yet"}…</div>
            </div>
          </div>
        ))}
        <div className="comm-sidebar-title" style={{ marginTop: 24 }}>Upcoming Sessions</div>
        {mentors.flatMap((m) =>
          m.sessions.filter((s) => s.status === "upcoming").map((s, i) => (
            <div key={`${m.id}-${i}`} className="upcoming-item">
              <div className="avatar xs" style={{ background: m.color }}>{m.name.split(" ").map((n) => n[0]).join("")}</div>
              <div>
                <div className="upcoming-topic">{s.topic}</div>
                <div className="upcoming-date">{s.date} · {s.time}</div>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="comm-main">
        {active ? <ChatPanel mentor={active} /> : <div className="no-chat">Select a mentor to chat</div>}
      </div>
      <div className="comm-right">
        <div className="comm-sidebar-title">Session History</div>
        {active &&
          active.sessions.map((s, i) => <SessionCard key={i} session={s} />)}
        <div className="comm-sidebar-title" style={{ marginTop: 16 }}>Shared Files</div>
        {["React Hooks Guide.pdf", "Assignment 3.js", "Performance Review.md"].map((f) => (
          <div key={f} className="file-item">
            <Icons.File /> <span>{f}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function ScheduleModal({ mentor, onClose }) {
  const [selected, setSelected] = useState(null);
  const [booked, setBooked] = useState(false);

  if (!mentor) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2 className="modal-title">Book a Session</h2>
            <p className="modal-sub">with {mentor.name}</p>
          </div>
          <button className="modal-close" onClick={onClose}><Icons.Close /></button>
        </div>
        {!booked ? (
          <>
            <div className="modal-slots">
              <div className="slots-label">Available Time Slots</div>
              <div className="slots-grid">
                {mentor.slots.map((slot) => (
                  <button
                    key={slot}
                    className={`slot-btn ${selected === slot ? "slot-selected" : ""}`}
                    onClick={() => setSelected(slot)}
                  >
                    {slot}
                  </button>
                ))}
              </div>
            </div>
            <button
              className="btn-confirm"
              disabled={!selected}
              onClick={() => setBooked(true)}
            >
              Confirm Booking {selected && `· ${selected}`}
            </button>
          </>
        ) : (
          <div className="booking-success">
            <div className="success-icon"><Icons.Sessions /></div>
            <h3>Session Booked!</h3>
            <p>Your session with {mentor.name} is confirmed for <strong>{selected}</strong></p>
            <button className="btn-confirm" onClick={onClose}>Done</button>
          </div>
        )}
      </div>
    </div>
  );
}

function DetailPanel({ mentor, onClose, onChat, onBook }) {
  if (!mentor) return null;
  const initials = mentor.name.split(" ").map((n) => n[0]).join("");
  return (
    <div className="detail-overlay" onClick={onClose}>
      <div className="detail-panel" onClick={(e) => e.stopPropagation()}>
        <button className="panel-close" onClick={onClose}><Icons.Close /></button>
        <div className="panel-hero" style={{ background: `linear-gradient(135deg, ${mentor.color}22, ${mentor.color}08)` }}>
          <div className="avatar lg" style={{ background: mentor.color }}>{initials}</div>
          <h2 className="panel-name">{mentor.name}</h2>
          <p className="panel-title">{mentor.title}</p>
          <StarRating rating={mentor.rating} />
          <p className="review-count">{mentor.reviewCount} reviews</p>
          <div className="expertise-tags">
            {mentor.expertise.map((t) => <span key={t} className="tag">{t}</span>)}
          </div>
        </div>
        <div className="panel-stats">
          <div className="stat-block">
            <div className="stat-num">{mentor.activeStudents}</div>
            <div className="stat-lab">Active Students</div>
          </div>
          <div className="stat-block">
            <div className="stat-num">{mentor.stats.successRate}%</div>
            <div className="stat-lab">Success Rate</div>
          </div>
          <div className="stat-block">
            <div className="stat-num">{mentor.stats.responseTime}</div>
            <div className="stat-lab">Avg Response</div>
          </div>
        </div>
        <div className="panel-section">
          <div className="panel-section-title">Courses Taught</div>
          {mentor.courses.map((c) => (
            <div key={c} className="course-row"><Icons.Book /> {c}</div>
          ))}
        </div>
        <div className="panel-section">
          <div className="panel-section-title">Performance Snapshot</div>
          <div className="metric">
            <div className="metric-label">Progress Improvement</div>
            <div className="metric-row">
              <ProgressBar value={mentor.stats.improvement} color={mentor.color} />
              <span className="metric-val" style={{ color: mentor.color }}>+{mentor.stats.improvement}%</span>
            </div>
          </div>
          <div className="metric">
            <div className="metric-label">Success Rate</div>
            <div className="metric-row">
              <ProgressBar value={mentor.stats.successRate} color="#10B981" />
              <span className="metric-val" style={{ color: "#10B981" }}>{mentor.stats.successRate}%</span>
            </div>
          </div>
        </div>
        <div className="perf-insight">
          <span className="insight-icon"><Icons.AI /></span>
          {mentor.insight}
        </div>
        <div className="panel-actions">
          <button className="btn-chat full" onClick={() => { onChat(mentor); onClose(); }}>
            <Icons.Chat /> Chat with Mentor
          </button>
          <button className="btn-book full" onClick={() => { onBook(mentor); onClose(); }}>
            <Icons.Sessions /> Book Session
          </button>
          <button className="btn-report-sm">
            <Icons.Report /> Report
          </button>
        </div>
      </div>
    </div>
  );
}

function ViewSwitcher({ active, onChange }) {
  const views = [
    { key: "cards", label: "Mentors", icon: "Cards" },
    { key: "analytics", label: "Performance", icon: "Analytics" },
    { key: "communication", label: "Communication", icon: "Communication" },
  ];
  return (
    <div className="view-switcher">
      {views.map((v) => {
        const IconComp = Icons[v.icon];
        return (
          <button
            key={v.key}
            className={`view-btn ${active === v.key ? "view-active" : ""}`}
            onClick={() => onChange(v.key)}
          >
            <IconComp /> {v.label}
          </button>
        );
      })}
    </div>
  );
}

// ─── MAIN PAGE ────────────────────────────────────────────────────────────────

export default function MyMentorsPage() {
  const [view, setView] = useState("cards");
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [scheduleMentor, setScheduleMentor] = useState(null);
  const [chatMentor, setChatMentor] = useState(null);
  const [filterStatus, setFilterStatus] = useState("All");
  const [animating, setAnimating] = useState(false);

  const switchView = (v) => {
    if (v === view) return;
    setAnimating(true);
    setTimeout(() => { setView(v); setAnimating(false); }, 220);
  };

  const filtered = filterStatus === "All" ? MENTORS : MENTORS.filter((m) => m.status === filterStatus);

  return (
    <MyStudentLayout>
    <div className="page-root">
      {/* HEADER */}
      <header className="page-header">
        <div className="header-text">
          <h1 className="page-title">My Mentors</h1>
          <p className="page-sub">Manage your learning relationships and track progress</p>
        </div>
        <div className="header-alert">
          <span className="alert-dot" />
          <Icons.AI />
          <span>New mentor match: <strong>Alex Rivera</strong> — 89% compatibility</span>
          <button className="alert-cta">View <Icons.Arrow /></button>
        </div>
      </header>

      {/* KPIs */}
      <div className="kpi-row">
        {KPI_DATA.map((k) => <KPIWidget key={k.label} {...k} />)}
      </div>

      {/* VIEW SWITCHER + FILTER */}
      <div className="controls-bar">
        <ViewSwitcher active={view} onChange={switchView} />
        {view === "cards" && (
          <div className="filter-bar">
            {["All", "Active", "Pending", "Requested"].map((f) => (
              <button key={f} className={`filter-btn ${filterStatus === f ? "filter-active" : ""}`} onClick={() => setFilterStatus(f)}>
                {f}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* MAIN VIEWS */}
      <div className={`view-container ${animating ? "view-fade-out" : "view-fade-in"}`}>
        {view === "cards" && (
          <div className="cards-grid">
            {filtered.map((m) => (
              <MentorCard
                key={m.id}
                mentor={m}
                onSelect={setSelectedMentor}
                onChat={(mentor) => { setChatMentor(mentor); setView("communication"); }}
                onBook={setScheduleMentor}
              />
            ))}
          </div>
        )}
        {view === "analytics" && (
          <div className="analytics-grid">
            {MENTORS.map((m) => <PerformanceCard key={m.id} mentor={m} />)}
          </div>
        )}
        {view === "communication" && (
          <CommView mentors={MENTORS} onChat={setChatMentor} />
        )}
      </div>

      {/* MODALS & PANELS */}
      {selectedMentor && (
        <DetailPanel
          mentor={selectedMentor}
          onClose={() => setSelectedMentor(null)}
          onChat={(m) => { setChatMentor(m); setView("communication"); }}
          onBook={setScheduleMentor}
        />
      )}
      {scheduleMentor && (
        <ScheduleModal mentor={scheduleMentor} onClose={() => setScheduleMentor(null)} />
      )}
    </div>
    </MyStudentLayout>
  );
}